// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ef-0";
export var actionModalContentContainer = "_ef-1";